import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getExamType, getGoal, getSingleStudent, userEditData, userRegister, userVerifyOtp } from "../../redux/services/studentSlice";
import { VscEyeClosed } from "react-icons/vsc";
import { RxEyeOpen } from "react-icons/rx";
import { useFormik } from "formik";
import * as Yup from "yup";
import { DatePicker } from "antd";
import moment from "moment-timezone";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import { fileUpload } from "../../redux/services/fileUploadSlice";
import { FaPlus, FaUserCircle } from "react-icons/fa";
import { getWorkshops } from "../../redux/services/workshopSlice";
import { getCourses } from "../../redux/services/courseSlice";

const UserForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const singleUserData = useSelector((state) => state.student?.singleStudentData);
  // const getGoalData = useSelector((state) => state.student?.goalData);
  const getExamTypeData = useSelector((state) => state.student?.examTypeData);
  const getWorkshopData = useSelector((state) => state.workshop?.workshopData);
  const getCourseData = useSelector((state) => state.course?.courseData);

  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [otpValue, setOtpValue] = useState();
  const queryParams = new URLSearchParams(location.search);
  const studentId = queryParams.get("studentId");
  const initialValues = {
    firstName: undefined,
    lastName: undefined,
    email: undefined,
    gender: undefined,
    dob: undefined,
    city: undefined,
    language: undefined,
    referralCode: undefined,
    contact: {
      countryCode: "+91",
      mobile: undefined,
    },
    upscNumber: undefined,
    password: undefined,
    profileImage: undefined,
    // civilServiceType: undefined,
    // goalId: undefined,
    examTypeId: [],
    workshopIds: [],
    courseIds: [],
  };
  const validationSchema = Yup.object({
    firstName: Yup.string().required("First Name is required"),
    lastName: Yup.string().required("Last Name is required"),
    email: Yup.string().email("Invalid email").required("Email is required"),
    // gender: Yup.string().required("Gender is required"),
    // dob: Yup.date().required("Date of Birth is required"),
    // city: Yup.string().required("City is required"),
    language: Yup.string().required("Language is required"),
    contact: Yup.object({
      countryCode: Yup.string().required("Language is required"),
      mobile: Yup.string()
        .matches(/^\d{10}$/, "Mobile number must be 10 digits")
        .required("Mobile number is required"),
    }),
    upscNumber: Yup.string().required("UPSC Number is required"),
    // civilServiceType: Yup.string().required("Civil Service is required"),
    password: Yup.string().min(6, "Password must be at least 6 characters").required("Password is required"),
    // goalId: Yup.string().required("Goal is required"),
    examTypeId: Yup.array().of(Yup.string().required("Exam Type selected")).min(1, "At least one Exam Type must be selected").required("Exam Type are required"),
    workshopIds: Yup.array().nonNullable(),
    courseIds: Yup.array().nonNullable(),
  });
  const onSubmit = async () => {
    setLoading(true);
    const payload = { ...values };
    if (studentId) {
      payload.userId = studentId;
    }
    try {
      let response;
      if (studentId) {
        response = await dispatch(userEditData(payload));
      } else {
        response = await dispatch(userRegister(payload));
      }
      if (response?.payload?.status === 200) {
        toast.success(response?.payload?.message);
        setOtpValue(response?.payload?.data?.otp);
        resetForm();
      } else {
      }
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };
  const verifyOtpHandler = useCallback(async () => {
    try {
      let response = await dispatch(
        userVerifyOtp({
          otp: otpValue.toString(),
          userType: "user",
        })
      );
      if (response?.payload?.status === 200) {
        navigate("/students");
      }
    } catch (error) {}
  }, [dispatch, otpValue, navigate]);

  useEffect(() => {
    if (otpValue) {
      verifyOtpHandler();
    }
  }, [otpValue, verifyOtpHandler]);
  const { values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue, setValues, resetForm } = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
  });
  const handleFileUpload = async (file) => {
    const formData = new FormData();
    formData.append("image", file);
    try {
      const response = await dispatch(fileUpload(formData));
      if (response) {
        setFieldValue("profileImage", response?.payload);
      }
    } catch (error) {
      console.error("File upload failed", error);
      alert("Error uploading file. Please try again.");
    }
  };

  const getUserDataById = useCallback(async () => {
    await dispatch(getSingleStudent(studentId));
  }, [dispatch, studentId]);

  useEffect(() => {
    if (studentId) {
      getUserDataById();
    }
  }, [studentId, getUserDataById]);
  useEffect(() => {
    if (studentId && singleUserData) {
      setValues({
        firstName: singleUserData?.firstName ?? undefined,
        lastName: singleUserData?.lastName ?? undefined,
        email: singleUserData?.email ?? undefined,
        gender: singleUserData?.gender ?? undefined,
        dob: moment(singleUserData?.dob).tz("Asia/Kolkata").format("YYYY-MM-DD"),
        city: singleUserData?.city ?? undefined,
        language: singleUserData?.language ?? undefined,
        // referralCode: singleUserData?.referralCode ?? undefined,
        upscNumber: singleUserData?.upscNumber ?? undefined,
        // civilServiceType: singleUserData?.civilServiceType ?? undefined,
        contact: {
          countryCode: singleUserData?.contact?.countryCode ?? undefined,
          mobile: singleUserData?.contact?.mobile ?? undefined,
        },
        password: singleUserData?.password ?? undefined,
        profileImage: singleUserData?.profileImage ?? undefined,
        // goalId: singleUserData?.goalId ?? undefined,
        examTypeId: singleUserData?.examTypeId ?? undefined,
        workshopIds: singleUserData?.workshopIds ?? undefined,
        courseIds: singleUserData?.courseIds ?? undefined,
      });
    }
  }, [studentId, singleUserData, setValues]);
  const languageOption = [
    { value: "english", label: "English" },
    { value: "hindi", label: "Hindi" },
  ];
  const genderOption = [
    { value: "male", label: "Male" },
    { value: "female", label: "Female" },
  ];
  const servicesOption = [
    { value: "IAS", label: "IAS" },
    { value: "IPS", label: "IPS" },
    { value: "IFS", label: "IFS" },
  ];
  // const goalOptions = getGoalData?.map((goal) => ({
  //   value: goal._id,
  //   label: goal.name,
  // }));
  const examTypeOptions = getExamTypeData?.map((exam) => ({
    value: exam._id,
    label: exam.name,
  }));
  const WorkshopDataOptions = getWorkshopData?.workshop_data?.map((workshop) => ({
    value: workshop._id,
    label: workshop.title,
  }));
  const CourseDataOptions = getCourseData?.course_data?.map((course) => ({
    value: course._id,
    label: course.title,
  }));
  const handleSelectAll = (selectedOptions) => {
    const selectedValues = selectedOptions ? selectedOptions.map((option) => option.value) : [];
    setFieldValue("examTypeId", selectedValues);
  };
  useEffect(() => {
    // dispatch(getGoal());
    dispatch(getExamType());
    dispatch(getWorkshops({}));
    dispatch(getCourses({}));
  }, [dispatch]);
  return (
    <div className="md:px-6 my-3">
      <div>
        <div className="bg-background pb-4">
          <div className="w-full sm:mx-auto">
            <div className="px-3 py-7 bg-card shadow rounded-3xl sm:p-10">
              <p className="text-3xl text-center pb-4 font-medium uppercase text-primary">{studentId ? "Edit" : "Add"} Student</p>
              <hr />
              <form className="mt-6" onSubmit={handleSubmit}>
                {studentId && (
                  <div className="mt-3 flex justify-center">
                    <div className="relative w-32 h-32">
                      <div className="w-32 h-32 rounded-full overflow-hidden border-2 border-border shadow-theme">{values?.profileImage ? <img src={values.profileImage} alt="Profile" className="w-full h-full object-cover" /> : <FaUserCircle className="text-muted-foreground w-full h-full" />}</div>

                      <label htmlFor="imageUpload" className="absolute bottom-1 right-2 bg-primary text-white p-2 rounded-full shadow cursor-pointer hover:bg-accent">
                        <FaPlus size={12} />
                      </label>

                      <input
                        id="imageUpload"
                        type="file"
                        accept="image/*"
                        className="hidden"
                        onChange={(e) => {
                          const file = e.target.files[0];
                          handleFileUpload(file);
                        }}
                      />
                    </div>
                  </div>
                )}
                <div className="grid mt-5 md:grid-cols-2 grid-cols-1 gap-5">
                  <div>
                    <label className="text-sm font-medium text-foreground">First Name</label>
                    <input type="text" name="firstName" className="w-full px-4 py-2 border border-border rounded-xl" value={values.firstName} onChange={handleChange} onBlur={handleBlur} placeholder="First Name" />
                    {touched.firstName && errors.firstName && <div className="text-red-500 text-sm">{errors.firstName}</div>}
                  </div>
                  <div>
                    <label className="text-sm font-medium text-foreground">Last Name</label>
                    <input type="text" name="lastName" className="w-full px-4 py-2 border border-border rounded-xl" value={values.lastName} onChange={handleChange} onBlur={handleBlur} placeholder="Last Name" />
                    {touched.lastName && errors.lastName && <div className="text-red-500 text-sm">{errors.lastName}</div>}
                  </div>
                  <div>
                    <label className="text-sm font-medium text-foreground">Email</label>
                    <input type="email" name="email" className="w-full px-4 py-2 border border-border rounded-xl" value={values.email} onChange={handleChange} onBlur={handleBlur} placeholder="Email" />
                    {touched.email && errors.email && <div className="text-red-500 text-sm">{errors.email}</div>}
                  </div>
                  {!studentId && (
                    <div>
                      <label className="text-sm font-medium text-foreground">Password</label>
                      <div className="relative w-full">
                        <input type={show ? "text" : "password"} name="password" className="w-full px-4 py-2 border border-border rounded-xl" value={values.password} onChange={handleChange} onBlur={handleBlur} placeholder="Password" />
                        <button type="button" onClick={() => setShow(!show)} className="absolute inset-y-0 end-0 flex items-center z-20 px-3 cursor-pointer text-primary rounded-e-xl focus:outline-none">
                          {show ? <VscEyeClosed /> : <RxEyeOpen />}
                        </button>
                      </div>
                      {touched.password && errors.password && <div className="text-red-500 text-sm">{errors.password}</div>}
                    </div>
                  )}

                  {!studentId && (
                    <div>
                      <label className="text-sm font-medium text-foreground">Referral Code</label>
                      <input
                        type="text"
                        name="referralCode"
                        className={`w-full px-4 py-2 border border-border rounded-xl ${studentId ? "bg-background" : ""}`}
                        value={values.referralCode}
                        onChange={(e) => {
                          setFieldValue("referralCode", e.target.value);
                        }}
                        onBlur={handleBlur}
                        placeholder="Referral Code"
                        disabled={!!studentId}
                        readOnly={!!studentId}
                      />
                    </div>
                  )}
                  <div>
                    <label className="text-sm font-medium text-foreground">Date of Birth</label>
                    <DatePicker className="w-full px-4 py-2 border border-border rounded-xl !outline-none" format="YYYY-MM-DD" value={values.dob ? moment(values.dob) : null} onChange={(_, dateString) => setFieldValue("dob", dateString)} onBlur={handleBlur} placeholder="Select Date" />
                    {touched.dob && errors.dob && <div className="text-red-500 text-sm">{errors.dob}</div>}
                  </div>
                  <div>
                    <label className="text-sm font-medium text-foreground">City</label>
                    <input type="text" name="city" className="w-full px-4 py-2 border border-border rounded-xl" value={values.city} onChange={handleChange} onBlur={handleBlur} placeholder="City" />
                    {touched.city && errors.city && <div className="text-red-500 text-sm">{errors.city}</div>}
                  </div>
                  <div>
                    <label className="text-sm font-medium text-foreground">Gender</label>
                    <Select name="gender" className="w-full text-base mt-1 h-[40px] rounded-xl focus:border-[#EB8844]" value={genderOption?.find((option) => option.value === values.gender)} onChange={(e) => setFieldValue("gender", e ? e.value : "")} options={genderOption} classNamePrefix="custom-select" />
                    {touched.gender && errors.gender && <div className="text-red-500 text-sm">{errors.gender}</div>}
                  </div>
                  <div>
                    <label className="text-sm font-medium text-foreground">UPSC Number</label>
                    <input type="text" name="upscNumber" className="w-full px-4 py-2 border border-border rounded-xl" value={values.upscNumber} onChange={handleChange} onBlur={handleBlur} placeholder="UPSC Number" />
                    {touched.upscNumber && errors.upscNumber && <div className="text-red-500 text-sm">{errors.upscNumber}</div>}
                  </div>
                  <div>
                    <label className="text-sm font-medium text-foreground">Language</label>
                    <Select name="language" className="w-full text-base mt-1 h-[40px] rounded-xl focus:border-[#EB8844]" value={languageOption?.find((option) => option.value === values.language)} onChange={(e) => setFieldValue("language", e ? e.value : "")} options={languageOption} classNamePrefix="custom-select" />
                    {touched.language && errors.language && <div className="text-red-500 text-sm">{errors.language}</div>}
                  </div>
                  {/* <div>
                    <label className="text-sm font-medium text-foreground">Goal</label>
                    <Select name="goalId" className="w-full text-base mt-1 h-[40px] rounded-xl focus:border-[#EB8844]" value={goalOptions?.find((option) => option.value === values.goalId)} onChange={(e) => setFieldValue("goalId", e ? e.value : "")} options={goalOptions} classNamePrefix="custom-select" />
                    {touched.goalId && errors.goalId && <div className="text-red-500 text-sm">{errors.goalId}</div>}
                  </div> */}
                  <div>
                    <label className="text-sm font-medium text-foreground">Exam Type</label>
                    <Select
                    isMulti
                      name="examTypeId"
                      className="w-full text-base mt-1 h-[40px] rounded-xl focus:border-[#EB8844]"
                      value={examTypeOptions?.filter((option) => values?.examTypeId?.includes(option.value))}
                      onChange={(selectedOptions) => {
                        const selectedValues = selectedOptions ? selectedOptions.map((option) => option.value) : [];
                        setFieldValue("examTypeId", selectedValues);
                      }}
                      options={examTypeOptions}
                      classNamePrefix="custom-select"
                    />
                    {touched.examTypeId && errors.examTypeId && <div className="text-red-500 text-sm">{errors.examTypeId}</div>}
                  </div>
                  <div>
                    <label className="text-sm font-medium text-foreground">Workshop</label>
                    <Select
                      isMulti
                      name="workshopIds"
                      className="w-full text-base mt-1 h-[40px] rounded-xl focus:border-[#EB8844]"
                      value={WorkshopDataOptions?.filter((option) => values?.workshopIds?.includes(option.value))}
                      onChange={(selectedOptions) => {
                        const selectedValues = selectedOptions ? selectedOptions.map((option) => option.value) : [];
                        setFieldValue("workshopIds", selectedValues);
                      }}
                      options={WorkshopDataOptions}
                      classNamePrefix="custom-select"
                    />
                    {touched.workshopIds && errors.workshopIds && <div className="text-red-500 text-sm">{errors.workshopIds}</div>}
                  </div>
                  <div>
                    <label className="text-sm font-medium text-foreground">Course</label>
                    <Select
                      isMulti
                      name="courseIds"
                      className="w-full text-base mt-1 h-[40px] rounded-xl focus:border-[#EB8844]"
                      value={CourseDataOptions?.filter((option) => values?.courseIds?.includes(option.value))}
                      onChange={(selectedOptions) => {
                        const selectedValues = selectedOptions ? selectedOptions.map((option) => option.value) : [];
                        setFieldValue("courseIds", selectedValues);
                      }}
                      options={CourseDataOptions}
                      classNamePrefix="custom-select"
                    />
                    {touched.courseIds && errors.courseIds && <div className="text-red-500 text-sm">{errors.courseIds}</div>}
                  </div>
                  <div>
                    <label className="text-sm font-medium text-foreground">Contact</label>
                    <div className="mt-1">
                      <div className="flex gap-3">
                        <PhoneInput
                          international
                          defaultCountry="IN"
                          value={values.contact.countryCode}
                          onChange={(value) => {
                            setFieldValue("contact.countryCode", value);
                          }}
                          onBlur={handleBlur}
                          className={`w-[100px] px-4 py-2 border border-border rounded-xl focus:outline-none ${studentId ? "bg-background" : ""}`}
                          placeholder="Country Code"
                          disabled={!!studentId}
                          readOnly={!!studentId}
                        />
                        <div className="w-full">
                          <input type="text" name="contact.mobile" className={`w-full px-4 py-2 border border-border rounded-xl ${studentId ? "bg-background" : ""}`} value={values.contact.mobile} onChange={handleChange} onBlur={handleBlur} placeholder="Mobile Number" disabled={!!studentId} readOnly={!!studentId} />
                        </div>
                      </div>
                      {touched.contact?.mobile && errors.contact?.mobile && <div className="text-red-500 text-sm">{errors.contact?.mobile}</div>}
                    </div>
                  </div>
                  {/* <div>
                    <label className="text-sm font-medium text-foreground">Civil Service Type</label>
                    <Select name="civilServiceType" className="w-full text-base mt-1 h-[40px] rounded-xl focus:border-[#EB8844]" value={servicesOption?.find((option) => option.value === values.civilServiceType)} onChange={(e) => setFieldValue("civilServiceType", e ? e.value : "")} options={servicesOption} classNamePrefix="custom-select" />
                    {touched.civilServiceType && errors.civilServiceType && <div className="text-red-500 text-sm">{errors.civilServiceType}</div>}
                  </div> */}
                </div>
                <div className="flex justify-center">
                  <button type="submit" className="w-full sm:w-[250px] min-h-[50px] flex justify-center font-semibold text-lg items-center text-white bg-primary rounded-xl hover:bg-accent mt-7">
                    {loading ? <div className="loader"></div> : "Save"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserForm;
